// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"922cc1c5","75":"19e14c2d","248":"685f91e0","390":"66a303ca","416":"58897d37","599":"1fd30e9b","978":"a3713c67"}[chunkId] + ".chunk.js";
};